import React from 'react'

export const PostTitle = ({ title, date }) => <h1>{title} <span style={{ fontSize: '10pt', fontWeight: '400' }}>{date}</span></h1>
